import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { createAuthClient } from "better-auth/react";

/** Native OAuth continuation adds only the provider's signed query to sign-in requests. */
export const authClient = createAuthClient({ plugins: [oauthProviderClient()] });
